export const TheatreRoyalDruryLane = {
  basketNote: {},
  colors: {
    venueLogoBackgroundColor: '#ffe6e1'
  },
  themeVenueLogo: 'trdl_sw_icon.png',
  themeVenueName: 'Theatre Royal Drury Lane',
  themeVenueAddress: 'Catherine Street, London WC2B 5JF'
}
